<template>
    <FormLayout icon="cogs" title="Account Settings" @save="setAccountDetails">

        <!-- <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul class="ml-0">
                <li><a href="#">Travel Admin</a></li>
                <li class="is-active"><a href="#" aria-current="page">Account Settings</a></li>
            </ul>
        </nav> -->

        <FormLayoutSection :title="titles.allowPersonalTravel" :description="descriptions.allowPersonalTravel">
            <b-radio v-model="accountDetails.allowPersonalTravel" :native-value="true" name="personal-travel">
                Allow personal travel to be booked
            </b-radio>
            <b-radio v-model="accountDetails.allowPersonalTravel" :native-value="false" name="personal-travel">
                Do not allow personal travel to be booked
            </b-radio>
        </FormLayoutSection>
        <FormLayoutSection :title="titles.preferredAirVendors" :description="descriptions.preferredVendors">
            <TagAutocomplete
                icon="airplane"
                :chainData="airlines"
                placeholder="Search by airline name"
                :selected="selectedPreferredAirVendors"
                @list="updatePreferredAirVendors"
            />
        </FormLayoutSection>
        <FormLayoutSection :title="titles.preferredCarVendors" :description="descriptions.preferredVendors">
            <TagAutocomplete
                icon="car"
                :chainData="carProviders"
                :selected="selectedPreferredCarVendors"
                placeholder="Search by car rental company name"
                @list="updatePreferredCarVendors"
            />
        </FormLayoutSection>
        <FormLayoutSection :title="titles.preferredHotelVendors" :description="descriptions.preferredVendors">
            <TagAutocomplete
                icon="bed"
                :chainData="hotelChains"
                placeholder="Search by hotel name"
                :selected="selectedPreferredHotelVendors"
                @list="updatePreferredHotelVendors"
            />
        </FormLayoutSection>
    </FormLayout>
</template>

<script>
import FormLayout from '@/layouts/FormLayout.vue';
import FormLayoutSection from '@/layouts/FormLayoutSection.vue';
import TagAutocomplete from '@/components/Tags/TagAutocomplete.vue';

export default {
    components: {
        FormLayout,
        TagAutocomplete,
        FormLayoutSection,
    },
    data() {
        return {
            accountDetails: {
                accountId: '',
                preferredAirVendors: [],
                preferredCarVendors: [],
                preferredHotelVendors: [],
                allowPersonalTravel: false,
            },
            selectedPreferredAirVendors: [],
            selectedPreferredCarVendors: [],
            selectedPreferredHotelVendors: [],
            titles: {
                preferredAirVendors: 'Preferred airlines',
                preferredHotelVendors: 'Preferred hotels',
                preferredCarVendors: 'Preferred rental car companies',
                allowPersonalTravel: 'Do you want to allow your organization\'s travelers to book personal travel using TripCircuit?',
            },
            descriptions: {
                allowPersonalTravel: {
                    intro: 'When booking personal travel on TripCircuit the following applies:',
                    items: [
                        'No travel policies are applied.',
                        'No unused tickets will be presented for use.',
                        'No central corporate ghost card will be available for use. Only payment methods associated with the traveler\'s profile will be available for use.',
                    ],
                },
                preferredVendors: {
                    intro: 'Setting your preferred vendors allows the following:',
                    items: [
                        'The ability to check for preferred vendor status is travel policy rules.',
                        'Highlighting preferred vendors in search results.',
                        'Filtering results by preferred vendor status.',
                    ],
                },
            },
        };
    },
    computed: {
        airlines() {
            return Object.entries(this.$globals.vendors.airlines);
        },
        accountId() {
            return this.$globals.currentTravellerProfile.account.id;
        },
        hotelChains() {
            return Object.entries(this.$globals.vendors.hotelChains);
        },
        carProviders() {
            return Object.entries(this.$globals.vendors.carProviders);
        },
    },
    async created() {
        this.accountDetails = await this.getAccountDetails();
        const { preferredAirVendors, preferredCarVendors, preferredHotelVendors } = this.accountDetails;
        this.selectedPreferredAirVendors = this.airlines.filter(airline => preferredAirVendors.includes(airline[0]));
        this.selectedPreferredCarVendors = this.carProviders.filter(carProvider => preferredCarVendors.includes(carProvider[0]));
        this.selectedPreferredHotelVendors = this.hotelChains.filter(hotelChain => preferredHotelVendors.includes(hotelChain[0]));
    },
    methods: {
        async getAccountDetails() {
            const data = { 'accountId': this.accountId };
            const response = await this.$app.huddleLabsServerCall('profile/account', data);
            const { id, name, ...accountDetails } = response.data;

            return { accountId: this.accountId, ...accountDetails };
        },
        async setAccountDetails() {
            const data = this.accountDetails;
            let result = await this.$app.huddleLabsServerCall('profile/account/save', data);

            console.log(result);

            if (result.error === false) {
                this.$buefy.toast.open({
                    message: 'Settings saved.',
                    type: 'is-success'
                })
            } else {
                this.$buefy.toast.open({
                    message: 'There was an error saving your settings.',
                    type: 'is-danger'
                })
            }
        },
        updatePreferredAirVendors(preferredAirVendors) {
            this.accountDetails.preferredAirVendors = preferredAirVendors.map(preferredAirVendor => preferredAirVendor[0]);
        },
        updatePreferredCarVendors(preferredCarVendors) {
            this.accountDetails.preferredCarVendors = preferredCarVendors.map(preferredCarVendor => preferredCarVendor[0]);
        },
        updatePreferredHotelVendors(preferredHotelVendors) {
            this.accountDetails.preferredHotelVendors = preferredHotelVendors.map(preferredHotelVendor => preferredHotelVendor[0]);
        },
    },
};
</script>
  